import IconCard from "components/IconCard";
import CardIelts from "components/Ielts/CardIelts";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import imgIeltsGeneral from "../media/ielts-general.jpg";
import ieltsAcademic from "../media/ielts-academic.jpg";
import AptisCard from "components/Aptis/AptisCard";
import Timeline from "components/Ielts/Timeline";
import ielts_2 from "../media/Ielts-4.jpg";
import footer from "../media/Ielts-5.jpg";
import TeacherCard from "components/Ielts/TeacherCard";
import Header from "components/Header";
import CarruselHorizontal from "components/Carrusel/CarruselHorizontal";


const Ielts = () => {
  const location = useLocation();
  const metodologias = [
    {
      met: "Material didáctico actualizado cada seis meses.",
      img: "https://brightonenglishcenter.edu.co/img/Habla.webp",
    },
    {
      met: "Simulacros del examen para que te familiarices con las condiciones reales de la prueba.",
      img: "https://brightonenglishcenter.edu.co/img/Comunicacion.jpeg",
    },
    {
      met: "Sesiones diseñadas para reforzar tus competencias en las cuatro habilidades clave.",
      img: "https://brightonenglishcenter.edu.co/img/habilidad_listening.jpg",
    },
  ];
  

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  });
  return (
    <>
      <Header
        titulo="IELTS"
        classTitulo=" text-white"
        info="Si necesitas demostrar tu nivel de inglés para estudiar, trabajar o
            vivir en un país de habla inglesa, el examen IELTS es la puerta que
            te brindará esas oportunidades."
        linkToSection="/certificaciones/ielts#info"
        botonDescripcion="Mas Información"
        classBoton="bg-white text-red-500 hover:bg-red-800 hover:text-white"
        img="https://brightonenglishcenter.edu.co/img/Ielts-3.webp"
      />
      <section id="info" className="w-full flex flex-col px-32 gap-10 my-32">
        <div className="flex flex-row items-center justify-center gap-10">
          <div className="w-1/2 h-[100vh] overflow-hidden rounded-30 group">
            <img
              width={1920}
              className="w-full h-full object-cover group-hover:scale-110 transition-all duration-300 ease-in-out"
              src={ielts_2}
              alt="Examen IELTS - Brighton Centro de Inglés"
            />
          </div>
          <div className="w-1/2 hyphens-none text-2xl space-y-5">
            <p className="">
              <strong>IELTS</strong> es uno de los exámenes más reconocidos a
              nivel mundial para certificar tu dominio del inglés, en{" "}
              <strong>Brighton Centro de Ingles </strong>
              contamos con{" "}
              <em>
                14 años de experiencia en la preparación para exámenes
                internacionales y somos un centro autorizado por el{" "}
                <strong>British Council</strong> en Pasto, Nariño desde 2014.
              </em>{" "}
              De esta manera ofrecemos el mejor respaldo para que logres tus
              objetivos migracionales, educativos o laborales.
            </p>
          </div>
        </div>
      </section>
      
      <section className="flex flex-col gap-10 items-start">
        <div className="px-32 w-2/3 space-y-5 ">
          <h3 className="text-6xl font-bold text-white font-Bebas">
            IELTS te abrira las puertas al mundo
          </h3>
          <p className="text-2xl">
            El examen <strong>IELTS</strong> está diseñado para evaluar tu
            desempeño en las cuatro habilidades lingüísticas esenciales:
          </p>
        </div>
        <div className="flex flex-row gap-5 w-full justify-center">
          <IconCard
            icono="fa-solid fa-headphones text-7xl text-red-500 transform"
            description="Listening"
          />
          <IconCard
            icono="fa-solid fa-book text-7xl text-red-500"
            description="Reading"
          />
          <IconCard
            icono="fa-solid fa-pen text-7xl text-red-500"
            description="Writing"
          />
          <IconCard
            icono="fa-regular fa-comments text-7xl text-red-500"
            description="Speaking"
          />
        </div>
        <p className="w-2/3 text-center mx-auto text-2xl">
          <em>
            Este examen identifica tu nivel de competencia en el idioma y te
            prepara para desenvolverte en contextos donde el inglés es el idioma
            principal.
          </em>
        </p>
      </section>
      <section className="p-20 flex flex-col gap-5">
        <h3 className="text-6xl font-bold text-center text-white font-Bebas">
          Presenta tu examen
        </h3>
        <p className="text-center text-2xl">
          EL examen <strong>IELTS</strong> tiene dos versiones que se realizan
          en <strong>papel</strong>.
        </p>
        <div className="w-full flex flex-row gap-10 justify-center">
          <CardIelts
            titulo="IELTS Academico"
            texto="Perfecto para quienes buscan ingresar a programas de pregrado o
              posgrado. Esta versión del examen incluye un vocabulario más
              exigente y preguntas complejas, que requieren análisis de gráficos
              y la redacción de ensayos académicos."
            url={ieltsAcademic}
          />
          <CardIelts
            titulo="IELTS General"
            texto="Diseñado para personas que necesitan demostrar su nivel de inglés
              en contextos laborales o con fines migratorios. Esta versión se
              enfoca en vocabulario menos complejo y contextos generales,
              incluyendo la elaboración de cartas formales y ensayos."
            url={imgIeltsGeneral}
          />
        </div>
      </section>
      <section>
        <div className="p-32 bg-primario">
          <h2 className="text-8xl font-bold text-white font-Bebas uppercase">
            CURSO DE PREPARACIÓN IELTS
          </h2>
        </div>
        <div className="w-full h-screen">
          <img
            src="https://brightonenglishcenter.edu.co/img/Ielts-4.webp"
            alt="IELTS"
            className="object-cover w-full h-full"
          />
        </div>
      </section>
      <section className="flex flex-row m-32 gap-10">
        <h3 className="w-1/2 text-5xl font-bold text-white font-Bebas text-right">
          ¿Quieres preparar tu examen IELTS con Brighton?
        </h3>
        <p className="w-1/2 hyphens-none text-2xl">
          En <strong>Brighton</strong>, ofrecemos un{" "}
          <em>curso de preparación</em> para el examen <strong>IELTS</strong>{" "}
          que te brinda todo lo necesario para alcanzar el puntaje que
          necesitas. Nuestro{" "}
          <em>
            contenido está actualizado y es impartido por instructores altamente
            calificados
          </em>
          , asegurando que recibas la mejor capacitación posible. Ya sea que te
          prepares para la versión Académica o General del examen, nuestro curso
          te ayudará a mejorar tus habilidades de manera significativa.
        </p>
      </section>
      <section className="space-y-10 ">
        <div className=" w-1/2 space-y-5 h-[50vh] mx-32">
          <h3 className="text-5xl font-Bebas font-bold text-white">
            Metodologia del curso
          </h3>
          <p className="text-2xl">
            <em>
              Nuestra metodología se basa en un enfoque práctico y orientado a
              resultados.
            </em>
          </p>
        </div>
        <div className="w-full">
          <CarruselHorizontal outputA="40%" outputB="-50%">
            {metodologias.map((m, i) => (
              <div
                  key={i}
                  className="relative w-[350px] h-[450px] bg-red-300 hyphens-none  overflow-hidden  group rounded-lg rounded-tl-none"
                >
                  <div className="absolute z-10 top-5 left-5 opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out ">
                    <img
                      width={520}
                      className="w-16 object-cover"
                      src="https://brightonenglishcenter.edu.co/img/Logo-2024.png"
                      alt="Brighton Centro de Ingles"
                    />
                  </div>
                  <img
                    width={520}
                    className="w-full h-full object-cover brightness-75 group-hover:brightness-100 transition-all duration-300 ease-in-out group-hover:scale-110"
                    src={m.img}
                    alt={m.met}
                  />
                  <p className="absolute w-full text-center -bottom-full p-5 h-auto rounded-t-[14px] bg-red-300 text-primario  group-hover:bottom-0 transition-all duration-300 ease-in-out font-bold">
                    {m.met}
                  </p>
                </div>
            ))}
          </CarruselHorizontal>
        </div>
      </section>
      <section className="bg-red-300 p-32">
          <div className="mx-20 flex flex-col gap-10">
          <h3 className="text-6xl font-bold text-red-500 font-Bebas">
            Conoce a nuestros instructores
          </h3>
          <div className="flex flex-row gap-5 ">
            <TeacherCard
              src="https://brightonenglishcenter.edu.co/img/Manuel_U.jpg"
              nombre="Manuel Urbano"
              habilidad="Reading"
              bio="Me enfoco en el componente de reading, empleando metodologías respaldadas por autores de referencia en el ámbito académico, las cuales adapto estratégicamente a mi propio enfoque de preparación. Acompaño al aspirante en su proceso proporcionando una guía estructurada, analítica y orientada a resultados."
            />
            <TeacherCard
              src="https://brightonenglishcenter.edu.co/img/Sally.jpg"
              nombre="Sally Johnson"
              habilidad="Listening / Speaking"
              bio="Me llamo Sally Johnson y soy profesora de inglés en Brighton School of Languages. Imparto clases a alumnos de nivel B1 a C1 y estoy especializada en las pruebas de expresión oral y comprensión auditiva de IELTS. Mis clases son interactivas y prácticas, y están diseñadas para fomentar la confianza en la comunicación y las habilidades para esta prueba."
            />
            <TeacherCard
              src="https://brightonenglishcenter.edu.co/img/Carlos-Santacruz.webp"
              nombre="Carlos Santacruz"
              habilidad="Writing"
              bio="Hola, soy instructor de IELTS por más de 20 años. He trabajado con una diversidad de estudiantes, me he especializado en el componente de escritura con resultados muy significativos por encima del estándar general."
            />
          </div>
        </div>
      </section>
      <section className="flex flex-col text-left bg-red-500 rounded-30 m-5">
        <div className="flex flex-col m-20">
          <h3 className="text-5xl font-bold font-Bebas text-white text-center">
            Fechas de inicio del curso y presentación del examen
          </h3>
          <div className="flex flex-row items-center gap-12">
            <p className="w-1/2 text-2xl">
              En <strong>Brighton</strong>, iniciamos el curso de entrenamiento{" "}
              <strong>IELTS</strong> dos veces al año, asi podras inscribirte y
              preparar tu examen con antelación. Consulta nuestro calendario
              para conocer las próximas fechas disponibles.
            </p>
            <Timeline />
          </div>
        </div>
        <div className="m-32 flex flex-col gap-20">
          <h3 className="text-5xl font-Bebas font-bold text-white">
            Requisitos para iniciar tu entrenamiento
          </h3>
          <div className="flex flex-row justify-center gap-20">
            <div className="w-1/2 flex flex-row text-left items-center gap-5 p-5 bg-white rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#0D2334] border-solid border-4 border-primario">
              <i class="fa-solid fa-ranking-star text-9xl text-red-500"></i>
              <p className="text-base hyphens-none">
                <em>
                  Para inscribirte en el curso de preparación para el examen{" "}
                  <strong>IELTS</strong>
                </em>
                , depende del puntaje final que debas obtener. Por ejemplo, si
                buscas obtener una <strong>banda C1</strong>, es recomendable
                tener un nivel{" "}
                <em>
                  <strong>intermedio-alto (B2+)</strong>
                </em>{" "}
                de inglés.
              </p>
            </div>
            <div className="w-1/2 flex flex-row text-left items-center gap-5 p-5 bg-white rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#0D2334] border-solid border-4 border-primario">
              <i class="fa-solid fa-file-circle-check text-9xl text-red-500"></i>
              <p className="text-base hyphens-auto">
                <em>
                  Realizar un <strong>examen de diagnóstico</strong> previo para
                  ajustar el curso a tus necesidades específicas.
                </em>
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="flex flex-row justify-between items-center  ">
        <div className="w-1/2 rounded-r-30 overflow-hidden group">
          <img
            src={footer}
            alt="Inscribete en nuestro curso de preparacion para el examen IELTS con Brighton"
            className="scale-125 group-hover:scale-[1.35] transition duration-300"
          />
        </div>
        <div className="w-1/2 flex flex-col gap-5 m-20">
          <h3 className="text-5xl text-left font-bold text-white font-Bebas">
            ¡Descubre cómo podemos ayudarte a alcanzar tus objetivos en el
            examen IELTS!
          </h3>
          <p className="text-left hyphens-auto ">
            ¡Contáctanos hoy mismo para obtener toda la información que
            necesitas sobre el examen <strong>IELTS</strong> y nuestro{" "}
            <strong>curso de entrenamiento </strong>
            especializado! Estamos aquí para ayudarte a alcanzar tus metas.
          </p>
          <a
            href="https://wa.link/7qju4g"
            target="_blank"
            rel="noreferrer"
            className="w-max text-4xl font-bold p-5 bg-white text-red-500 rounded-full rounded-tl-none hover:bg-red-800 hover:text-white"
          >
            Escribenos{" "}
          </a>
        </div>
      </div>
    </>
  );
};

export default Ielts;
